import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { helper } from 'src/environments/helper';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    private httpOptions: any;
    helper = helper;

    private basePath = environment.interop.basePath;
    private notificationsUrl =
        this.basePath +
        environment.interop.indoc.notifications.authNotifications;

    private notificationSource = new BehaviorSubject<{
        id: string;
        name: string;
    }>({ id: '-1', name: 'none' });
    currentNotification = this.notificationSource.asObservable();

    constructor(private http: HttpClient) { }

    async warningSwal(title: any, text: any, icon: any) {
        return await Swal.fire({
            icon: icon,
            title: title,
            text: text,
            // footer: '<a href>Why do I have this issue?</a>'
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'Închide'
        });
    }

    async successSwal(title: any, text: any) {
        return await Swal.fire({
            icon: 'success',
            title: title,
            text: text,
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: helper.dialogConfig.buttonLabels.close,
        });
    }

    async confirmSwal(title: any, text: any, confirmButtonText: string = 'Da', cancelButtonText: string = 'Nu') {
        return await Swal.fire({
            icon: 'question',
            title: title,
            text: text,
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText,
            reverseButtons: true,
        });
    }

    changeNotification(notification: { id: string; name: string }) {
        this.notificationSource.next(notification);
    }

    getNotifications() {
        return this.http
            .get(this.notificationsUrl, this.httpOptions)
            .pipe(map((response: any) => response.data));
    }
}
